import React from 'react'
import renderContent from '../../utilities/renderContent'
import './style.css'
import { Parallax } from 'react-parallax';

// import imgTreatment from './images/*'



// function importAll(r) {
//   return r.keys().map(r);
// }

// const images = importAll(require.context('./images', false, /\.(png|jpe?g|svg)$/));


const ConditionList = ({ conditions }) => {

  return (
    <div className="conditions">
      <div className="container">
        <h1>Conditions</h1>
        {
          Object.keys(conditions).map((key) => {
            const condition = conditions[key]

            return (
              <div key={key}>
                <h3>{condition.name}</h3>
                {condition.content &&
                  <div>
                    {renderContent(condition.content)}
                  </div>
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

const Condition = ({ conditions }) => {
  var image_dom = null;
  if (conditions.images != undefined){
    image_dom = conditions.images.map(function(image, key){
        return (
          <img src={image}
            className="image-treatment"
            draggable="false"
            alt={conditions.name}
            key={key}
          />
        )
      }
    )
  }
  return (
    <div className="condition">
      <div className="page-bg">
        {/* treatment.images[0] */}
        <Parallax bgImage="../../images/conditions/00.jpg" strength={150} className="page-parallax">
        </Parallax>
      </div>
      <div className="container container-parallax">
        <div className="parallax-container">
          <div className="content">
            <div className="left">
              {image_dom}
            </div>
            <div className="right">
              <div className="condition-title">{conditions.name}</div>
              {renderContent(conditions.content)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Conditions = ({ data, match }) => {
  // console.log(match.params.conditionChildId)
  // console.log(data.conditions[match.params.conditionId].child[match.params.conditionChildId])
  if (match && match.params.conditionId !== undefined && data.conditions[match.params.conditionId].child[match.params.conditionChildId] !== undefined) {
    return <Condition conditions={data.conditions[match.params.conditionId].child[match.params.conditionChildId]} />
  } else {
    return <ConditionList conditions={data.conditions} />
  }
}

export default Conditions



// WEBPACK FOOTER //
// ./src/components/Conditions/index.js